import React, { useRef, useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import * as am4plugins_wordCloud from "@amcharts/amcharts4/plugins/wordCloud";

am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_material);

function WordCloud({ wordCloudData }) {
  const chart = useRef(null);

  useLayoutEffect(() => {
    if (!wordCloudData) return null;
    const x = am4core.create("chartdiv", am4plugins_wordCloud.WordCloud);
    x.responsive.enabled = true;
    const series = x.series.push(new am4plugins_wordCloud.WordCloudSeries());

    series.accuracy = 3;
    series.step = 15;
    series.rotationThreshold = 0.7;
    series.maxCount = 200;
    series.minWordLength = 1;
    // series.labels.template.tooltipText = "{word}: {value}";
    series.labels.template.tooltipText = "{word}: [bold]{value}[/]";
    series.fontFamily = "Courier New";
    series.maxFontSize = am4core.percent(30);

    // series.colors = new am4core.ColorSet();
    // series.colors.passOptions = {};

    // series.heatRules.push({
    //   target: series.labels.template,
    //   property: "fill",
    //   min: am4core.color("#ffaaaa"),
    //   max: am4core.color("#ff5555"),
    //   dataField: "value",
    // });

    const heatColors = [
      am4core.color("#12c2e9"),
      am4core.color("#c471ed"),
      am4core.color("#f64f59"),
    ];

    // custom function to get a three-color-heatmap
    series.labels.template.adapter.add("fill", function (fill, labels) {
      const workingValue = labels.dataItem.values["value"].workingValue;
      const minValue = series.dataItem.values["value"].low;
      const maxValue = series.dataItem.values["value"].high;
      const percent = (workingValue - minValue) / (maxValue - minValue);
      if (am4core.type.isNumber(percent)) {
        if (percent > 0.005) {
          return new am4core.Color(
            am4core.colors.interpolate(heatColors[1].rgb, heatColors[2].rgb, percent * 3)
          );
        } else {
          return new am4core.Color(
            am4core.colors.interpolate(heatColors[0].rgb, heatColors[1].rgb, (percent + 0.05) * 2)
          );
        }
      }
      return fill;
    });

    // series.events.on("arrangestarted", function (ev) {
    //   ev.target.baseSprite.preloader.show(0);
    // });

    // series.events.on("arrangeprogress", function (ev) {
    //   ev.target.baseSprite.preloader.progress = ev.progress;
    // });

    series.data = wordCloudData;

    series.dataFields.word = "tag";
    series.dataFields.value = "weight";

    x.logo.disabled = true;
    chart.current = x;

    return () => {
      x.dispose();
    };
  }, [wordCloudData]);

  return (
    <>
      <div id="chartdiv" style={{ maxWidth: "1000px", width: "100%", height: "500px" }} />
    </>
  );
}
export default WordCloud;
